import symbol from '@/assets/fluxus-symbol.png';
import { cn } from '@/lib/cn';

/**
 * Logotipo oficial da Fluxus (DEC-034): o símbolo num quadrado branco arredondado — legível no tema claro, no
 * escuro e sobre a cor da marca — e "Fluxus BSC" ao lado. Trocar a arte aqui troca o logo em todo o app.
 */
export function BrandLogo({
  className,
  compact = false,
  inverse = false,
}: {
  className?: string;
  compact?: boolean;
  /** Sobre o painel da marca (azul do logo, texto branco). */
  inverse?: boolean;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 font-extrabold tracking-tight', className)}>
      <img
        src={symbol}
        alt=""
        aria-hidden
        width={36}
        height={36}
        className={cn(
          'size-9 shrink-0 rounded-[10px] bg-white object-contain',
          inverse ? 'shadow-sm' : 'ring-1 ring-border',
        )}
      />
      {compact ? (
        <span className="sr-only">Fluxus BSC</span>
      ) : (
        <span className="text-lg leading-none">
          Fluxus <span className={inverse ? 'text-brand-panel-foreground/75' : 'text-brand'}>BSC</span>
        </span>
      )}
    </span>
  );
}
